export const serviceDefinitions = {
  'Arts and Culture': {
    id: 10000,
    description:
      'Efforts to support the development of, exposure to, or increased engagement with culture or arts.',
  },
  'Civic Engagement, Advocacy, and Systems Change': {
    id: 10001,
    description:
      'Efforts to empower individuals to participate in civic life, engage in advocacy efforts, and promote community well-being at ' +
        'a systems level.',
  },
  'Community and Neighborhood Revitalization': {
    id: 10002,
    description:
      'Efforts to improve the quality of life for neighborhood residents including beautification projects, shared community ' +
        'resources, and safety improvements.',
  },
  'Community Economic Development': {
    id: 10003,
    description:
      'Efforts to improve economic conditions and public resources at a community-level.',
  },
  'Community Resiliency': {
    id: 10004,
    description:
      'Efforts to increase community capacity to withstand disruption and plan for the future related to education, income, health, ' +
        'culture, and environment.',
  },
  'Small Business and Non-Profit Support': {
    id: 10005,
    description:
      'Efforts to support the development, growth, and success of small businesses and nonprofits.',
  },
  'Transit and Mobility': {
    id: 10006,
    description:
      'Efforts to promote access to safe, sustainable, and affordable transit and mobility options.',
  },
  'Workforce Development': {
    id: 10007,
    description:
      'Efforts to support individuals in securing and retaining employment through workforce development, vocational / skills-based ' +
        'training, professional development and / or job placement.',
  },
  'Disaster Preparation': {
    id: 10008,
    description:
      'Efforts to increase resilience, planning, and recovery to reduce the occurrence and/or severity of damage from emergencies, ' +
        'disasters, and conflicts.',
  },
  'Disaster Response': {
    id: 10009,
    description:
      'Efforts to provide immediate and/or long-term support to people impacted by emergencies, disasters, and conflict.',
  },
  'Diversity, Equity, Inclusion, and Accessibility': {
    id: 10010,
    description:
      'Efforts to promote diversity, equity, inclusion, and accessibility.',
  },
  'Gender Equity': {
    id: 10011,
    description:
      'Efforts to address and reduce discrimination based on gender, such as empowering girls, women, and trans communities',
  },
  'Human Rights': {
    id: 10012,
    description:
      'Efforts to protect or promote the human rights and/or civil liberties of individuals or communities, especially of ' +
        'marginalized or vulnerable groups such as children.',
  },
  'Racial Justice': {
    id: 10013,
    description:
      'Efforts to support, protect, and empower people and communities of color.',
  },
  'Early Childhood Development': {
    id: 10014,
    description:
      'Efforts to support early childhood development in the first few years of life including cognitive, motor, and social and ' +
        'emotional learning.',
  },
  'Education: K-12 Classroom': {
    id: 10015,
    description:
      'Efforts to promote skills, interests and motivation in K-12 classrooms.',
  },
  'Education: Out-of-School Programming': {
    id: 10016,
    description:
      'Efforts to promote skills, interests, and motivation through out-of-classroom support such as extracurricular exhibits, ' +
        'events, workshops, and/or membership organizations.',
  },
  'Education: Post-secondary, Career Development': {
    id: 10017,
    description:
      'Efforts to promote skills, interests, and professional development in a post-secondary school environment such as a 2- or ' +
        '4-year college, or professional credentialing or certificate program.',
  },
  'Educational Access': {
    id: 10018,
    description:
      'Efforts to improve access to academic educational services such as distance learning and tutoring.',
  },
  'Scholarships and Fellowships': {
    id: 10019,
    description:
      'Efforts to increase access to financial support for formal and extracurricular education opportunities.',
  },
  'STEM Education: K-12 Classroom': {
    id: 10020,
    description:
      'Efforts to promote STEM-related skills, interests, motivation, and appreciation for STEM as an inviting career path, and ' +
        'improve performance in K-12 classrooms.',
  },
  'STEM Education: Out-of-School Programming': {
    id: 10021,
    description:
      'Efforts to promote STEM-related skills, interest, and motivation through out-of-classroom support such as extracurricular ' +
        'exhibits, events, workshops, and/or membership organizations',
  },
  'STEM Education: Post-secondary, Career Development': {
    id: 10022,
    description:
      'Efforts to promote STEM-related skills, interests, and professional development in a post-secondary school environment such ' +
        'as a 2- or 4-year college, or professional credentialing or certificate program.',
  },
  'Educator Training': {
    id: 10023,
    description:
      'Efforts to provide training, curricula, and/or other educational materials and support to teachers in order to improve ' +
        'academic performance and engagement.',
  },
  'Environmental Conservation': {
    id: 10024,
    description:
      'Efforts to restore, protect, or enhance environmental resources and natural ecosystems.',
  },
  'Recycling and Waste': {
    id: 10025,
    description:
      'Efforts to reduce material usage, increase recycling / reuse, and/or improve waste management practices.',
  },
  'Sustainable Agriculture': {
    id: 10026,
    description:
      'Efforts to promote farming in sustainable ways that meet present needs without compromising the ability of future generations ' +
        'to meet their needs.',
  },
  'Sustainable Business Practices': {
    id: 10027,
    description:
      'Efforts to create new processes, products, or services that reduce negative environmental/climate impacts of businesses ' +
        'through significant energy efficiency improvements, the sustainable use of resources, and/or environmental protection ' +
        'activities.',
  },
  'Wildlife Conservation': {
    id: 10028,
    description:
      'Efforts to promote animal welfare and/or protect wild species and their natural habitats.',
  },
  'Community and School-Based Meal Programs': {
    id: 10029,
    description:
      'Efforts to improve food security of individuals through place-based meal programs such as school lunches or senior programs.',
  },
  'Food Distribution': {
    id: 10030,
    description:
      'Efforts to improve food security through provision of food and related services.',
  },
  'Growing and Harvesting': {
    id: 10031,
    description:
      'Efforts to improve food security through growing and harvesting programs such as community and school gardens.',
  },
  Health: {
    id: 10032,
    description:
      'Efforts to improve physical, mental, social, and emotional health and well-being.',
  },
  'Health Education and Behavior Change': {
    id: 10033,
    description:
      'Efforts to improve health through education and behavior change approaches.',
  },
  'Health Systems, Policy, Advocacy, and Research': {
    id: 10034,
    description:
      'Efforts to improve health through local, national, and international policy change, advocacy, research, and systems-level ' +
        'approaches.',
  },
  'Recreation and Play': {
    id: 10035,
    description:
      'Efforts to improve physical, mental, and social and emotional health and well-being through recreation, sports, and ' +
        'nature-based approaches.',
  },
  'Water Access, Sanitation, and Hygiene': {
    id: 10036,
    description:
      'Efforts to ensure access to safe drinking water and/or improve access to sanitation/hygiene-related services.',
  },
  'Affordable Housing': {
    id: 10037,
    description:
      'Efforts to support individuals or families to attain, retain, or improve their long-term housing situation.',
  },
  'Basic Needs': {
    id: 10038,
    description:
      'Efforts to improve individual or family well-being through provision of basic needs and related services.',
  },
  'Economic Security': {
    id: 10039,
    description:
      'Efforts to reduce poverty and improve the economic security and stability of people.',
  },
  'Emergency Housing': {
    id: 10040,
    description:
      'Efforts to improve individual or family well-being through provision of short-term housing and related basic needs support.',
  },
  'Positive Youth Development': {
    id: 10041,
    description:
      'Efforts to support positive youth development including academic success, social emotional learning, skills development, ' +
        'leadership, and connection to community.',
  },
  'Public Safety': {
    id: 10042,
    description:
      'Efforts to promote and protect the health and safety of community members through first response and crisis management.',
  },
};
